/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookOpenIcon16Light } from './BookOpenIcon16Light';
import { BookOpenIcon16Regular } from './BookOpenIcon16Regular';
import { BookOpenIcon16Solid } from './BookOpenIcon16Solid';
import { BookOpenIcon20Light } from './BookOpenIcon20Light';
import { BookOpenIcon20Regular } from './BookOpenIcon20Regular';
import { BookOpenIcon20Solid } from './BookOpenIcon20Solid';
import { BookOpenIcon24Regular } from './BookOpenIcon24Regular';
import { BookOpenIcon24Solid } from './BookOpenIcon24Solid';
import { BookOpenIcon32Regular } from './BookOpenIcon32Regular';
import { BookOpenIcon64Regular } from './BookOpenIcon64Regular';
var sizes = {
    16: {
        light: BookOpenIcon16Light,
        regular: BookOpenIcon16Regular,
        solid: BookOpenIcon16Solid,
    },
    20: {
        light: BookOpenIcon20Light,
        regular: BookOpenIcon20Regular,
        solid: BookOpenIcon20Solid,
    },
    24: {
        regular: BookOpenIcon24Regular,
        solid: BookOpenIcon24Solid,
    },
    32: {
        regular: BookOpenIcon32Regular,
    },
    64: {
        regular: BookOpenIcon64Regular,
    },
};
export var BookOpenIcon = forwardRef('BookOpenIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
